import * as React from 'react';
import { Box, Thumbnail, TextButton, Text, Button } from '@wix/design-system';
import { RefreshSmall } from '@wix/wix-ui-icons-common';
import s from './ChoosePlanPerks.scss';
export const ChoosePlanPerks = _ref => {
  let {
    data: {
      planPerks
    },
    context: {
      send,
      onWidgetAction
    }
  } = _ref;
  const [selectedPerks, setSelectedPerks] = React.useState({});
  const sendSelectedPerks = () => {
    const perks = Object.entries(selectedPerks).filter(_ref2 => {
      let [, value] = _ref2;
      return value;
    });
    if (perks.length === 0) {
      onWidgetAction(PRICING_PLANS_CHOOSE_PERKS, {
        action: 'select none'
      });
      return send('None of these suits me.');
    }
    onWidgetAction(PRICING_PLANS_CHOOSE_PERKS, {
      action: 'select',
      value: perks
    });
    return send(`I'll add ${perks.map(_ref3 => {
      let [perk] = _ref3;
      return `"${perk}"`;
    }).join(', ')}.`);
  };
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: 2,
    paddingTop: "SP1",
    paddingBottom: "SP1",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin"
  }, "Choose features to highlight"), planPerks.map(perk => {
    return /*#__PURE__*/React.createElement(Thumbnail, {
      selected: Boolean(selectedPerks[perk]),
      className: s.buttonWrapper,
      onClick: () => setSelectedPerks({
        ...selectedPerks,
        [perk]: !selectedPerks[perk]
      })
    }, /*#__PURE__*/React.createElement(Box, {
      padding: "SP2"
    }, /*#__PURE__*/React.createElement(Text, {
      skin: "primary",
      size: "small"
    }, perk)));
  }), /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle",
    align: "space-between",
    paddingRight: "SP1",
    paddingTop: "SP2"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: sendSelectedPerks,
    size: "tiny",
    className: s.button
  }, "Highlight Features"), /*#__PURE__*/React.createElement(TextButton, {
    onClick: () => {
      send('Regenerate please.');
      onWidgetAction(PRICING_PLANS_CHOOSE_PERKS, {
        action: 'regenerate'
      });
    },
    prefixIcon: /*#__PURE__*/React.createElement(RefreshSmall, null),
    size: "tiny",
    className: s.icon
  }, "Create Again")));
};
export const PRICING_PLANS_CHOOSE_PERKS = 'PRICING_PLANS_CHOOSE_PERKS';
//# sourceMappingURL=ChoosePlanPerks.js.map